import 'react';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import '../chunk-ad6ad343.js';
import 'airbnb-prop-types';
import '../parseIcons.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import './styled.js';
import { a as Icon } from '../chunk-16546651.js';
export { a as Icon, c as iconDefaultProps, b as iconPropTypes } from '../chunk-16546651.js';
export default Icon;